/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './LinkWithChevron.style';

import BaseLink from './BaseLink';
import ChevronIcon from 'src/shared/ui/component/icon/ChevronIcon';

type Props = {
  href?: string | null,
  state?: Object,
  children: React.Node,
  layoutClass?: string,
  onClick?: ?(Event) => void,
  handleMouseOver?: () => void,
  inNewWindow?: boolean,
  'aria-haspopup'?: ?string | boolean,
};

const useStyles = createUseThemeStyles(styles);

const LinkWithChevron = ({
  href,
  state,
  children,
  layoutClass,
  onClick,
  handleMouseOver,
  inNewWindow,
  'aria-haspopup': ariaHaspopup,
}: Props): React.Node => {
  /*
   |------------------------------------------------------------------------------
   | Hooks
   |------------------------------------------------------------------------------
   */

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const rootClasses = classNames(classes.root, layoutClass);

  return (
    <BaseLink
      className={rootClasses}
      href={href}
      state={state}
      onClick={onClick}
      onMouseOver={handleMouseOver}
      newWindow={inNewWindow}
      aria-haspopup={ariaHaspopup}
    >
      {children}
      &nbsp;
      <span className={classes.icon}>
        <ChevronIcon right />
      </span>
    </BaseLink>
  );
};

export default React.memo<Props>(LinkWithChevron);
